import { CapacitorUpdater } from "@capgo/capacitor-updater";

import { resetAppInfoCache } from "@/lib/utils/app-info";

// Só avisa o Capgo que o bundle subiu (senão ele faz rollback). O splash nativo
// não sai daqui: quem esconde é o BootGate, quando a primeira rota resolve.
export const initAutoUpdate = (): void => {
  void CapacitorUpdater.notifyAppReady()
    .catch(() => undefined)
    .finally(resetAppInfoCache);
};
